import netcoServer from '../../apis/netcoServer';
import {GET_ALL_TIMESTAMP_SERVERS} from "../types";
import tableLoadingCall from '../helpers/tableLoadingCall';

const getAllTimestampServers= (page, pageSize, sidx, sord) => async (dispatch) => {
  let formData = {
    limit: pageSize,
    skip: (page - 1) * pageSize,
    sidx: sidx === 'userStatus' ? 'locked' : sidx,
    sord: sord ? renderSord(sord) : '',
  };
  await tableLoadingCall(dispatch, () => netcoServer.newPost('/SystemService/getAllTimestampServers', formData), GET_ALL_TIMESTAMP_SERVERS, onSuccessPayload);
};

const renderSord = sord => {
  return sord === 'ascend' ? 'asc' : 'desc';
};

const onSuccessPayload = data => {
  return {
    reportList: {
      kind: 'servers',
      total: data.result.total,
      entries: data.result.timeStampServers
    }
  };
};
export default getAllTimestampServers;